// Swatch Category Header Injection (i288 + TFT)
// Adds visual category dividers in the swatch picker
// Removable: delete this file from theme assets/
// History:
//   2026-05-19: 統合 — クイーン3色をスムース革、セレック1色(オークエナメル)をエナメルに統合
//   2026-05-19: TFT 21色サポートを追加（4カテゴリ: カーフ・C.F.S・アノネイ スムース・アノネイ 型押し）

(function() {
  'use strict';

  const SUFFIX = document.body.dataset.templateSuffix;
  if (!SUFFIX || (SUFFIX !== 'i288' && SUFFIX.indexOf('i288-') !== 0 && SUFFIX !== 'tft')) return;

  // ============================================================
  // i288 (39色, 6カテゴリ)
  // ============================================================
  const I288_MAP = {
    // Smooth (8): KIP + 山陽キップ + クイーン
    'ブラック': 'smooth',
    'オーク': 'smooth',
    'ベージュ': 'smooth',
    'ライトグレー': 'smooth',
    'ピンクベージュ': 'smooth',
    'ミルキーホワイト': 'smooth',
    'ペパーミント': 'smooth',
    'アクアブルー': 'smooth',
    // Suede (10): ASIAGO SUEDE
    'グレーベージュスエード': 'suede',
    'ブルーベージュスエード': 'suede',
    'ブラックスエード': 'suede',
    'ハニーベージュスエード': 'suede',
    'ライトグレースエード': 'suede',
    'サーモンピンクスエード': 'suede',
    'シナモンベージュスエード': 'suede',
    'モーブモーンスエード': 'suede',
    'ミントグリーンスエード': 'suede',
    'ライトイエロースエード': 'suede',
    // Enamel (7): ライト/メタリック/キップエナ + セレック
    'アッシュベージュエナメル': 'enamel',
    'パウダリーピンクエナメル': 'enamel',
    'サンドベージュエナメル': 'enamel',
    'アイボリーエナメル': 'enamel',
    'ルミナスイエローエナメル': 'enamel',
    'パールブラックエナメル': 'enamel',
    'オークエナメル': 'enamel',
    // Croco (3)
    'カーキ・クロコ型押': 'croco',
    'ブラック・クロコ型押': 'croco',
    'ベージュクロコ型押': 'croco',
    // Metallic (2)
    'シャンパンゴールド': 'metallic',
    'シアーシルバー': 'metallic',
    // Waterproof (9)
    '晴雨兼用クロスムース': 'waterproof',
    '晴雨兼用ネイビー': 'waterproof',
    '晴雨兼用ベージュ': 'waterproof',
    '晴雨兼用D.グレースエード': 'waterproof',
    '晴雨兼用ブルーベージュスエード': 'waterproof',
    '晴雨兼用クロスエード': 'waterproof',
    '晴雨兼用ブラウニッシュグレー': 'waterproof',
    '晴雨兼用アンバーブラウン': 'waterproof',
    '晴雨兼用マッドレッド': 'waterproof',
  };

  const I288_LABELS = {
    smooth: { name: 'スムース革', note: '' },
    suede: { name: 'スエード', note: '' },
    enamel: { name: 'エナメル', note: '' },
    croco: { name: 'クロコ型押', note: '' },
    metallic: { name: 'メタリック', note: '' },
    waterproof: { name: '晴雨兼用', note: '' },
  };

  // ============================================================
  // TFT (21色, 4カテゴリ)
  // ============================================================
  const TFT_MAP = {
    // Calf (3) - 基準価格
    'カーフ・ブラック': 'calf',
    'カーフ・ダークブラウン': 'calf',
    'カーフ・ブラウン': 'calf',
    // C.F.S スエード (7) - +¥5,500
    'C.F.S・ブラック': 'cfs',
    'C.F.S・ダークブラウン': 'cfs',
    'C.F.S・ブラウン': 'cfs',
    'C.F.S・キャメル': 'cfs',
    'C.F.S・ベージュ': 'cfs',
    'C.F.S・ネイビー': 'cfs',
    'C.F.S・チャコールグレー': 'cfs',
    // Annonay smooth (4) - +¥33,000
    'アノネイ・ブラック': 'annonay_smooth',
    'アノネイ・ダークネイビー': 'annonay_smooth',
    'アノネイ・バーガンディ': 'annonay_smooth',
    'アノネイ・ブラウン': 'annonay_smooth',
    // Annonay embossed (7) - +¥33,000
    'スモールグレイン・ブラック': 'annonay_emb',
    'スモールグレイン・ダークブラウン': 'annonay_emb',
    'スモールグレイン・ブラウン': 'annonay_emb',
    'ミドルグレイン・ブラック': 'annonay_emb',
    'ミドルグレイン・ブラウン': 'annonay_emb',
    'エレファント・ブラック': 'annonay_emb',
    'エレファント・ダークブラウン': 'annonay_emb',
  };

  const TFT_LABELS = {
    calf:           { name: 'カーフ',           note: '(基準価格)' },
    cfs:            { name: 'C.F.S スエード',   note: '+¥5,500' },
    annonay_smooth: { name: 'アノネイ スムース', note: '+¥33,000' },
    annonay_emb:    { name: 'アノネイ 型押し',   note: '+¥33,000' },
  };

  // ============================================================
  // ディスパッチ
  // ============================================================
  const IS_I288 = SUFFIX === 'i288' || SUFFIX.indexOf('i288-') === 0;
  const CATEGORY_MAP    = IS_I288 ? I288_MAP    : TFT_MAP;
  const CATEGORY_LABELS = IS_I288 ? I288_LABELS : TFT_LABELS;

  // Inject category headers into the swatches UL within rootNode
  function injectHeadersIntoNode(rootNode) {
    const wrappers = rootNode.querySelectorAll('.variant-input-wrapper[data-option-slug]');
    let targetUl = null;

    for (const w of wrappers) {
      const label = w.querySelector('.form__label .flex.gap-2');
      if (label && label.textContent.includes('素材')) {
        targetUl = w.querySelector('ul.swatches');
        break;
      }
    }

    if (!targetUl) return;
    // 既に見出しliが入っていればスキップ（重複防止）
    if (targetUl.querySelector('.i288-cat-header')) return;

    let lastCategory = null;
    Array.from(targetUl.children).forEach((li) => {
      const input = li.querySelector('input[data-option-value]');
      if (!input) return;
      const value = input.getAttribute('data-option-value');
      const cat = CATEGORY_MAP[value];
      if (!cat) return;

      if (cat !== lastCategory) {
        lastCategory = cat;
        const labelEntry = CATEGORY_LABELS[cat] || { name: cat, note: '' };
        const header = document.createElement('li');
        header.className = 'i288-cat-header';
        header.setAttribute('data-category', cat);
        const noteHtml = labelEntry.note
          ? ` <span class="i288-cat-note">${labelEntry.note}</span>`
          : '';
        header.innerHTML = `<span class="i288-cat-label">${labelEntry.name}</span>${noteHtml}`;
        targetUl.insertBefore(header, li);
      }
    });
  }

  // 既存DOMに対する注入（document全体を対象に）
  function injectHeaders() {
    injectHeadersIntoNode(document);
  }

  // ★ 核心: <product-info> の preProcessHtmlCallbacks に登録して、
  // テーマがviewTransitionで置換する「新DOM」に置換前にヘッダーを書き込む
  // これによりちらつきがゼロになる
  function registerPreProcessCallback() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return false;
    if (productInfo.dataset.i288CallbackRegistered === 'true') return true;
    if (!Array.isArray(productInfo.preProcessHtmlCallbacks)) return false;
    productInfo.dataset.i288CallbackRegistered = 'true';
    productInfo.preProcessHtmlCallbacks.push((newVariantPickerNode) => {
      injectHeadersIntoNode(newVariantPickerNode);
    });
    return true;
  }

  // Run on initial page load
  function initialSetup() {
    injectHeaders();
    registerPreProcessCallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSetup);
  } else {
    initialSetup();
  }

  // <product-info> が遅れて connectedCallback されるケースの保険
  setTimeout(registerPreProcessCallback, 500);
  setTimeout(registerPreProcessCallback, 1500);

  // Also run on variant updates (保険、preProcessCallback が効かないケース用)
  document.addEventListener('variant:change', () => setTimeout(injectHeaders, 50));
  // Catch theme re-renders via mutation observer too (フォールバック)
  const observer = new MutationObserver(() => {
    setTimeout(injectHeaders, 50);
  });
  const observeTarget =
    document.querySelector('product-info') ||
    document.querySelector('main-product, .product, [data-page-type="product"]') ||
    document.body;
  observer.observe(observeTarget, { childList: true, subtree: true });
})();
